import { ENTITY_LEVEL } from '../../../common/constants/integrationConstants/crmConstants';
import {
  zedeskAuthentication,
  zendeskEntityMapping,
  validateIntegration,
  disconnectIntegration,
  goToMappingStep,
  fetchZendeskEntityMapping,
  changeMappingSavedStatus,
} from '../../routines/integrations/zendeskRoutines';

const initialState = {
  active: false,
  authenticationSuccess: false,
  modalError: false,
  modalLoading: false,
  mappingSuccess: false,
  orgMapping: null,
  userMapping: null,
  accountMapping: null,
  historicalTicketSync: false,
  mappingSavedStatus: false,
  mappingError: false,
  errorMsg: null,
  modalPhase: 1,
  integrationLoading: false,
  integrationError: false,
  mappingLoading: false,
};

const zendeskeReducer = (state = initialState, action) => {
  switch (action.type) {
    case zendeskEntityMapping.TRIGGER:
    case zedeskAuthentication.TRIGGER:
      return {
        ...state,
        modalLoading: true,
        modalError: false,
      };
    case validateIntegration.TRIGGER:
    case disconnectIntegration.TRIGGER:
      return {
        ...state,
        integrationLoading: true,
        integrationError: false,
      };
    case zedeskAuthentication.SUCCESS:
      return {
        ...state,
        modalLoading: false,
        authenticationSuccess: true,
      };
    case validateIntegration.SUCCESS: {
      const { authenticationSuccess, mappingSuccess, active } =
        action.payload && action.payload.data;
      return {
        ...state,
        authenticationSuccess,
        mappingSuccess,
        active,
        integrationLoading: false,
        modalPhase: authenticationSuccess && mappingSuccess ? 2 : 1,
      };
    }
    case zendeskEntityMapping.SUCCESS: {
      const { entityMapping } = action.payload.data;
      return {
        ...state,
        modalLoading: false,
        mappingSuccess: true,
        mappingSavedStatus: true,
        orgMapping: entityMapping?.orgMapping,
        userMapping: entityMapping.userMapping,
        accountMapping: entityMapping?.accountMapping,
        historicalTicketSync: entityMapping.historicalTicketSync,
      };
    }
    case disconnectIntegration.SUCCESS:
      return {
        ...state,
        integrationLoading: false,
        active: false,
        modalPhase: 1,
        authenticationSuccess: false,
        mappingSuccess: false,
      };
    case zedeskAuthentication.FAILURE:
      return {
        ...state,
        modalLoading: false,
        authenticationSuccess: false,
        active: false,
        modalError: true,
      };
    case zendeskEntityMapping.FAILURE:
      return {
        ...state,
        modalLoading: false,
        mappingSuccess: false,
        modalError: true,
      };
    case validateIntegration.FAILURE:
    case disconnectIntegration.FAILURE:
      return {
        ...state,
        integrationLoading: false,
        integrationError: true,
      };
    case goToMappingStep.TRIGGER:
      return {
        ...state,
        modalPhase: 2,
      };
    case fetchZendeskEntityMapping.TRIGGER:
      return {
        ...state,
        mappingLoading: true,
        modalError: false,
      };
    case fetchZendeskEntityMapping.SUCCESS: {
      const {
        entityMapping: { organization, account, contact, historicalTicketSync },
      } = action.payload;
      return {
        ...state,
        orgMapping: organization || {
          velarisEntity: ENTITY_LEVEL.ORGANIZATION,
        },
        userMapping: contact || {
          velarisEntity: ENTITY_LEVEL.CONTACT,
          zendeskEntity: 'endUser',
        },
        accountMapping: account || { velarisEntity: ENTITY_LEVEL.ACCOUNT },
        historicalTicketSync: historicalTicketSync || false,
        mappingSavedStatus:
          Object.keys(action.payload.entityMapping).length !== 0,
        mappingLoading: false,
      };
    }

    case changeMappingSavedStatus.TRIGGER:
      return {
        ...state,
        mappingSavedStatus: action.payload,
      };

    default:
      return state;
  }
};

export default zendeskeReducer;
